(function () {
	var jUsername = document.getElementById('j_username');
	var jPassword = document.getElementById('j_password');
	var businessTermsCheckbox = document.getElementById('businessTermsCheckbox');
	var loginSubmitButton = document.getElementById('loginSubmitButton');
	var registerSubmitButton = document.getElementById('registerSubmitButton');

	// Function to check conditions for login button
	function checkLoginConditions() {
		if (jUsername.value.trim() !== '' && jPassword.value.trim() !== '' && businessTermsCheckbox.checked) {
			loginSubmitButton.disabled = false;
		} else {
			loginSubmitButton.disabled = true;
		}
	}

	// Function to check conditions for register button
	function checkRegisterConditions() {
		if (businessTermsCheckbox.checked) {
			registerSubmitButton.disabled = false;
		} else {
			registerSubmitButton.disabled = true;
		}
	}

	// Event listeners for login form
	if (jUsername && jPassword && businessTermsCheckbox && loginSubmitButton) {
		jUsername.addEventListener('input', checkLoginConditions);
		jPassword.addEventListener('input', checkLoginConditions);
		businessTermsCheckbox.addEventListener('change', checkLoginConditions);

		checkLoginConditions();
	}

	// Event listener for register form
	if (businessTermsCheckbox && registerSubmitButton) {
		businessTermsCheckbox.addEventListener('change', checkRegisterConditions);

		checkRegisterConditions();
	}

})();
